import { Amplify } from 'aws-amplify';
import { authConfig } from '../config/auth-config';

// Run once at module load. main.tsx imports this module so it executes
// before any component mounts.
//
// `identityPoolId` + `allowGuestAccess: true` give `fetchAuthSession()`
// access to Cognito Identity Pool credentials — guest IAM credentials
// for signed-out visitors, authenticated IAM credentials for signed-in
// users. The SPA's signed-fetch helper (`auth/signedFetch.ts`) uses
// these to call IAM-authed Lambda Function URLs (username/email
// availability checks).
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: authConfig.userPoolId,
      userPoolClientId: authConfig.userPoolClientId,
      identityPoolId: authConfig.identityPoolId,
      allowGuestAccess: true,
    },
  },
});
